import { axiosInstance } from '@/shared/api/axios';
import {
  CheckCountGetResponseType,
  CheckCountHistoryGetRequestType,
  CheckCountHistoryGetResponseType,
  CheckExecutionHistoryGetRequestType,
  CheckExecutionHistoryGetResponseType,
  NoCheckCountGetResponseType,
  NoticeGetResponseType,
  ReducedTimeMinutesGetRequestType,
  ReducedTimeMinutesGetResponseType,
  ReducedTimeMinutesHistoryGetRequestType,
  ReducedTimeMinutesHistoryGetResponseType,
  CreditManagementDownloadHistoryGetResponseType,
  CreditManagementDownloadHistoryGetRequestType,
  RegistryDownloadHistoryGetResponseType,
  RegistryDownloadHistoryGetRequestType,
  CheckDecisionGetResponseType,
  UsageHistoryGetRequestType,
  UsageHistoryGetResponseType,
  GroupUsageHistoryGetRequestType,
  GroupUsageHistoryGetResponseType,
  AccountUsageHistoryGetRequestType,
  AccountUsageHistoryGetResponseType,
  OtherUsageHistoryGetRequestType,
  OtherUsageHistoryGetResponseType,
  AiCreditHistoryGetRequestType,
  AiCreditHistoryGetResponseType,
} from '@/shared/types/api/api.dashboard';

export const getNotice = async (): Promise<NoticeGetResponseType[]> => {
  const { data } = await axiosInstance.get<NoticeGetResponseType[]>(`dashboard/notice`);
  return data;
};

export const getCheckCount = async (): Promise<CheckCountGetResponseType> => {
  const { data } = await axiosInstance.get<CheckCountGetResponseType>('dashboard/check-count');
  return data;
};

export const getNoCheckCount = async (): Promise<NoCheckCountGetResponseType> => {
  const { data } = await axiosInstance.get<NoCheckCountGetResponseType>('dashboard/no-check-count');
  return data;
};

export const getCheckCountHistory = async ({
  fromYearMonth,
  toYearMonth,
}: CheckCountHistoryGetRequestType): Promise<CheckCountHistoryGetResponseType> => {
  const { data } = await axiosInstance.get<CheckCountHistoryGetResponseType>(
    `dashboard/check-count-history`,
    {
      params: {
        fromYearMonth,
        toYearMonth,
      },
    },
  );
  return data;
};

export const getCheckExecutionHistory = async ({
  fromYearMonth,
  toYearMonth,
}: CheckExecutionHistoryGetRequestType): Promise<CheckExecutionHistoryGetResponseType> => {
  const { data } = await axiosInstance.get<CheckExecutionHistoryGetResponseType>(
    `dashboard/check-execution-history`,
    {
      params: {
        fromYearMonth,
        toYearMonth,
      },
    },
  );
  return data;
};

export const getAiCreditHistory = async ({
  fromYearMonth,
  toYearMonth,
}: AiCreditHistoryGetRequestType): Promise<AiCreditHistoryGetResponseType> => {
  const { data } = await axiosInstance.get<AiCreditHistoryGetResponseType>(
    `dashboard/ai-credit-history`,
    {
      params: {
        fromYearMonth,
        toYearMonth,
      },
    },
  );
  return data;
};

export const getCreditManagementDownloadHistory = async ({
  fromYearMonth,
  toYearMonth,
}: CreditManagementDownloadHistoryGetRequestType): Promise<CreditManagementDownloadHistoryGetResponseType> => {
  const { data } = await axiosInstance.get<CreditManagementDownloadHistoryGetResponseType>(
    `dashboard/credit-management-downloads-history`,
    {
      params: {
        fromYearMonth,
        toYearMonth,
      },
    },
  );
  return data;
};

export const getRegistryDownloadHistory = async ({
  fromYearMonth,
  toYearMonth,
}: RegistryDownloadHistoryGetRequestType): Promise<RegistryDownloadHistoryGetResponseType> => {
  const { data } = await axiosInstance.get<RegistryDownloadHistoryGetResponseType>(
    `dashboard/registry-downloads-history`,
    {
      params: {
        fromYearMonth,
        toYearMonth,
      },
    },
  );
  return data;
};

export const getReducedTimeHistory = async ({
  fromYearMonth,
  toYearMonth,
}: ReducedTimeMinutesHistoryGetRequestType): Promise<ReducedTimeMinutesHistoryGetResponseType> => {
  const { data } = await axiosInstance.get<ReducedTimeMinutesHistoryGetResponseType>(
    `dashboard/reduced-time-history`,
    {
      params: {
        fromYearMonth,
        toYearMonth,
      },
    },
  );
  return data;
};

export const getReducedTimeMinutes = async ({
  fromYearMonth,
  toYearMonth,
}: ReducedTimeMinutesGetRequestType): Promise<ReducedTimeMinutesGetResponseType> => {
  const { data } = await axiosInstance.get<ReducedTimeMinutesGetResponseType>(
    `dashboard/reduced-time-minutes`,
    {
      params: {
        fromYearMonth,
        toYearMonth,
      },
    },
  );

  return data;
};

export const getCheckDecision = async (): Promise<CheckDecisionGetResponseType> => {
  const { data } = await axiosInstance.get<CheckDecisionGetResponseType>(
    'dashboard/check-decision',
  );
  return data;
};

export const getUsageHistory = async ({
  fromYearMonth,
  toYearMonth,
}: UsageHistoryGetRequestType): Promise<UsageHistoryGetResponseType> => {
  const { data } = await axiosInstance.get<UsageHistoryGetResponseType>('dashboard/usage-history', {
    params: { fromYearMonth, toYearMonth },
  });
  return data;
};

export const getGroupUsageHistory = async ({
  fromYearMonth,
  toYearMonth,
}: GroupUsageHistoryGetRequestType): Promise<GroupUsageHistoryGetResponseType> => {
  const { data } = await axiosInstance.get<GroupUsageHistoryGetResponseType>(
    'dashboard/group-usage-history',
    { params: { fromYearMonth, toYearMonth } },
  );
  return data;
};

export const getAccountUsageHistory = async ({
  fromYearMonth,
  toYearMonth,
}: AccountUsageHistoryGetRequestType): Promise<AccountUsageHistoryGetResponseType> => {
  const { data } = await axiosInstance.get<AccountUsageHistoryGetResponseType>(
    'dashboard/account-usage-history',
    { params: { fromYearMonth, toYearMonth } },
  );
  return data;
};

export const getOtherUsageHistory = async ({
  fromYearMonth,
  toYearMonth,
}: OtherUsageHistoryGetRequestType): Promise<OtherUsageHistoryGetResponseType> => {
  const { data } = await axiosInstance.get<OtherUsageHistoryGetResponseType>(
    'dashboard/other-usage-history',
    { params: { fromYearMonth, toYearMonth } },
  );
  return data;
};
